import { render, staticRenderFns } from "./ReferenceFromAFriend.vue?vue&type=template&id=308195e3&"
import script from "./ReferenceFromAFriend.vue?vue&type=script&lang=js&"
export * from "./ReferenceFromAFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports